import { axios } from "utils";

import { ADMIN_SOILAI_URL as endpoint } from "consts";

import { Coordinates } from "models";

type TimeSpan = {
  startYear: number;
  endYear: number;
};

export const getSoilAICropModelSummary = async (data: unknown) => axios.get(`${endpoint}/crop-model-summary`, { data });

export const getSoilAICropPredictions = async (data: unknown) => axios.post(`${endpoint}/crop-predictions`, { data });

export const getSoilAICropHeatmap = async (data: unknown) => axios.post(`${endpoint}/crop-heatmap`, { data });

export const getSoilAIContentRecommendations = async (data: unknown) => axios.post(`${endpoint}/content-recommendations`, { data });

export const getSoilAIRelatedContent = async (data: unknown) => axios.post(`${endpoint}/related-content`, { data });

export const getSoilAISearchedContent = async (data: unknown) => axios.post(`${endpoint}/search-content`, { data });

export const getSoilAIVisualisation = async (data: unknown) => axios.post(`${endpoint}/crop-visualisation`, { data });

export const getSoilAIFlyovers = async (data: unknown) => axios.post(`${endpoint}/flyovers`, { data });

export const getSoilFieldDelineation = async (data: unknown) => axios.post(`${endpoint}/delineation`, { data });

export const getNdviScores = async (data: {
  fieldId: string;
  geometry: Coordinates[];
  center: Coordinates;
  timeSpan?: TimeSpan;
  cloudCover?: number;
}): Promise<
  {
    ndvi: {
      min: number;
      max: number;
      mean: number;
      stDev: number;
    };
    date: string;
  }[]
> => axios.post(`${endpoint}/ndvi-scores`, { data });
